import events from 'events';
let sock = null
let socket = {

}
Object.freeze(socket);
export default socket;